<template>
<!-- <div><br> -->
<!-- <div style="margin-top:20px; text-align:justify;" v-if="activo==0"> -->
  <!-- <div class="columns"> -->
    

  <div> 
    
  <div style="background-color:#B588DF; margin-left:10px; margin-right:10px;" class="column is-fluid">

    <strong style="color:white;">Tour</strong>
    <input v-model="servicio" class="input">

    <strong style="color:white;">Tipo de tour</strong>
    <input v-model="tipoName" class="input">
    
    <strong style="color:white;">Fecha del tour</strong> <br> 
<!-- <div style="align:center;"> -->
    <date-pick v-model="fecha" style="z-index:999;">
      
    </date-pick>
<!-- </div> -->

    <br><br >
    <label ><strong style="color:white;">Tipo de INE (Elige Nacional o Quintana Roo)</strong></label><br>
    <div class="select is-fullwidth">
      <select v-model="nacionalidadId" >
        <option value="1" selected>Nacional</option>
        <option value="3">Quintana Roo</option>
      </select>
    </div>

      <table class="table is-fullwidth" style="background:#B588DF; margin-top: 10px;">
        <tbody>
          <tr>
            <td>

              
                <label><strong style="color:white;">Adultos y adolecentes (11 años y más)</strong></label>

            </td>
            <td align="center">

                <div class="select">
                  <select v-model="adultos">
                    <option value=0>0</option>
                    <option value=1>1</option>
                    <option value=2>2</option>
                    <option value=3>3</option>
                    <option value=4>4</option>
                    <option value=5>5</option>
                    <option value=6>6</option>
                    <option value=7>7</option>
                    <option value=8>8</option>
                    <option value=9>9</option>
                    <option value=10>10</option>
                  </select>
                </div>

              

            </td>
          </tr>
          <tr v-if="admiteNino==1">
            <td>
              
              
                <label><strong style="color:white;">Menores (5 a 10 años)</strong></label>

            </td>
            <td align="center">

                <div class="select">
                  <select v-model="ninos">
                    <option value=0>0</option>
                    <option value=1>1</option>
                    <option value=2>2</option>
                    <option value=3>3</option>
                    <option value=4>4</option>
                    <option value=5>5</option>
                  </select>
                </div>
              

            </td>
            </tr>
          <tr>
            <td>

              
                <strong style="color:white;">Infantes (0 a 4 años)</strong>

            </td>
            <td align="center">

                <div class="select">
                  <select v-model="infantes">
                    <option value=0>0</option>
                    <option value=1>1</option>
                    <option value=2>2</option>
                  </select>
                </div>
              

            </td>
          </tr>
        </tbody>
      </table>

      

    <!-- </div> -->
    <!-- <div v-if="adultos>0" style="margin-top:-20px; background-color:#F9FFF8; text-align:center; border-radius: 15px; "> -->
    <!-- <span style="color:#565656;" v-if="this.tourInformation.data[0].id!=36">Total ${{cantidadTotal}} MXN</span> <br v-if="adultos>0 && this.tourInformation.data[0].id!=36" >
    <strong style="color:#565656;">RESERVA CON </strong> <strong style="color:#B588DF; font-size:30px;">${{cantidadParaReservar}}</strong> <br v-if="adultos>0">
    <span v-if="this.tourInformation.data[0].id!=36" style="color:#565656;">Liquida el resto al abordar!</span> -->
    <!-- </div> -->

    <strong style="color:white;">Cantidad Total</strong>
    <input v-model="cantidadTotal" class="input">

    <strong style="color:white;">Cantidad para reservar</strong>
    <input v-model="cantidadParaReservar" class="input">

    <strong style="color:white;">Cantidad por pagar</strong>
    <input v-model="cantidadBalance" class="input">

    <!-- <button v-if="adultos>0" class="button is-light is-small is-fullwidth" onClick="parent.location='https://www.facebook.com/Exodus-M%C3%A9xico-691083214335683'" target="_blank" style="margin-top:10px;">o solicita aquí el pago de ${{this.cantidadTotalMes}}* MXN/mes en Facebook</button> -->
      <!-- <div style="text-align:center;"> -->
        <!-- <span class="is-small" style="color:white; text-align:center;"> o ${{this.cantidadTotalMes}} MXN por 12 meses </span> -->
      <!-- </div> -->
    <br v-if="adultos>0">
    <strong style="color:white;">Nombre</strong>
    <input v-model="cliente" class="input">

    <strong style="color:white;">e-mail</strong>
    <input v-model="mail" class="input">

    <strong style="color:white;">Teléfono</strong>
    <input v-model="telefono" class="input">

    <strong style="color:white;">Lugar de salida</strong>
    <input v-model="lugarSalida" class="input">

    <strong style="color:white;">Hora de salida</strong>
    <input v-model="horaSalida" class="input">

    <br><br>

    <textarea class="textarea" v-model="observaciones" placeholder="Comentarios (opcional)"></textarea>

    <strong style="color:white;">Confirmación</strong>
    <!-- <input :v-model="getConfirmacion()" class="input"> -->
    {{getConfirmacion}}

    <!-- <button class="button" @click="reservar()">Reservar</button> -->

    <!-- <p style="color:white; text-align:justify;" v-if="this.tourInformation.data[0].id==36"> Esta reservación sólo será válida con el pago vía transferencia o depósito bancario 7 días antes de la fecha de salida. Cuenta Santander 5579 1002 9345 5935. </p> -->
    <input class="button is-fullwidth" @click="reservar()" type="submit" value="Reserva">

    



  </div>
  </div>
   <!-- <div :class="(this.modalConfirmacion)?'modal is-active':'modal'" align="center">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <span class="modal-card-title">
                <strong>Gracias por reservar</strong>
              </span>
              <button class="delete" @click="cerrarModalConfirmacion()" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
              <span v-text="this.cliente"></span>, su número de confirmación es el siguiente
              <strong><span class="is-size-2" v-text="this.confirmacion" ></span></strong>
              <br>
              Hemos enviado el cupón vía correo electrónico. Revise su bandeja principal y/o la de bandeja de spam. Favor de presentarlo junto con el pago de PayPal para hacer válido el servicio.

            </section>
            <footer class="modal-card-foot">
              <button @click="cerrarModalConfirmacion()" class="button is-info is-fullwidth">Entendido</button>
            </footer>
          </div>
        </div>
  </div> -->
  

 

<!-- </div> -->


</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
// import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
  components:{
    DatePick,
    VueClockPicker,
    // Carousel3d,
    // Slide
  },
  data () {
    return {
      // format: 'DD-MMMM-YYYY',
      subSelect:'',
      toursList:[],
      tiposList:[],
      tiposGeneralesList:[],
      idiomasList:[],
      nacionalidadesList:[],
      salidasList:[],
      tour:'',
      tour2:'',
      tour3:'',
      tour4:'',
      tipo:'',
      nacionalidad:'',
      idioma:'',
      salida:'',
      fecha:'',
      // fecha:moment().add(1, 'day').format('DD-MMMM-YYYY'),
      fecha2:'',
      fecha3:'',
      fecha4:'',
      hora:'',
      searchText:'',
      searchText2:'',
      items:[],
      items2:[],
      hotel:'',
      hotelId:'',
      hotelPickup:'',
      vendedor:'',
      vendedorId:null,
      adultos:0,
      ninos:0,
      infantes:0,
      cliente:'',
      mail:'',
      // cliente:'Jean test',
      habitacion:'',
      cupon:'',
      balance:0,
      moneda:null,
      monedasList:[],
      observaciones:'',
      confirma:'',
      servicio:1,
      horario:1,
      cortesia:2,
      testObject:[],
      files: '',
      imagen: null,

      host: 'exodus.sistemy.mx',
      tourInformation:[],
      tipoElegido:'',
      servicio:'',

      descripcion:'',
      recomendaciones:'',
      incluye :'',
      noIncluye:'',

      lugarSalida:'',
      horaSalida:'',
      duracion:'',
      mapa:'',

      admiteNino:'',
      admiteInfante:'',

      reportarAdulto:'',
      reportarMenor:'',
      reportarInfante:'',
      reportarInsen:'',
      comisionAdulto:'',
      comisionMenor:'',
      comisionInfante:'',
      comisionInsen:'',
      gananciaAdulto:'',
      gananciaMenor:'',
      gananciaInfante:'',
      gananciaInsen:'',

      diasAnticipacion:'',
      dosPorUno: '',
      activo:'',

      files:'',
      newFileName:'',
      serviceImage:'',
      descripcionImage:'',
      serviceImages: [],
      publicAdult:'',
      pagoMes:'',
      cantidadTotalMes:'',
      publicMenor: '',
      publicInfante: '',
      carouselReady:false,
      nacionalidadId:'1',

      cantidadTotal:'',
      cantidadParaReservar:'',
      cantidadBalance:'',
      telefono:'',
      // telefono:9982420807,
      tipoName:'',
      modalConfirmacion: false
      
      // host: 'localhost'

    }
  },
  created(){
    // console.log("path in tour",this.$route.path)
    // console.log(this.$route.params.id,'<-- route')
    // this.tourInfo();
    
    // this.getTiposGenerales();
    // this.getServiceImages();
    
    // this.getHoteles();
    // this.getVendedores();
    // this.getMonedas();
    // this.getTours();
    // this.getIdiomas();
    // this.getNacionalidades();
    // this.getSalidas();
  },
  computed:{
    getConfirmacion () {
      this.confirmacion=(this.cliente.substr(0,2)).toUpperCase()+this.servicio.substr(0,2)+moment(this.fecha).format('DD')+moment(this.fecha).format('MM')+moment().format('HHmm')+'H'+this.adultos;
      return this.confirmacion
    },
  //   itemsSearched : function(){
  //     var self = this;
  //     if( self.searchText == ''){
  //       return self.items;
  //     }
  //     return self.items.filter(function(item){

  //       var str = self.searchText;
  //       var res = str.toUpperCase();

  //       return item.nombre.includes(res);
  //     });
  //   },
  //   itemsSearched2 : function(){
  //     var self = this;
  //     if( self.searchText2 == ''){
  //       return self.items2;
  //     }
  //     return self.items2.filter(function(item){

  //       var str = self.searchText2;
  //       var res = str.toUpperCase();

  //       return item.nombre.includes(res);
  //     });
  //   }
  },
  methods:{
    clear () {
      this.adultos = 0
      this.ninos = 0
      this.infantes = 0
      this.cliente = 'Test'
      this.mail = ''
      this.telefono = ''
      this.observaciones = ''
    },
    reservar () {
      // this.saveBooking()
      if(this.nacionalidadId==1){
        var ine = 'Nacional, No Quintanarroense';
      }else{
        var ine = 'Quintanarroense';
      }
      var params = {
        credencial : ine,
        confirmacion : this.confirmacion,
        servicio: this.servicio,
        tipo: this.tipoName,
        cliente: this.cliente,
        telefono: this.telefono,
        mail: this.mail,
        lugarSalida: this.lugarSalida,
        horaSalida: this.horaSalida,
        fecha: this.fecha,
        adultos: this.adultos,
        ninos: this.ninos,
        infantes: this.infantes,
        cantidadTotal: this.cantidadTotal,
        cantidadParaReservar: this.cantidadParaReservar,
        cantidadBalance: this.cantidadBalance,
      }
      axios.post(`https://${this.host}/enviarCupon.php`,qs.stringify(params))
          .then((response) => {
            if (response.status == 200 ) {
              console.log("enviado")
            }else{
              console.log('error');
            }
          });
    },
    cerrarModalConfirmacion:function(){
      this.modalConfirmacion=false
      this.clear();
      // $("#modalConfirmacion").removeClass("is-active");
    },
  },
  mixins: [searchMix]
}
</script>
